/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagingHeader } from '../models/PagingHeader';
import type { TerminalContract } from '../models/TerminalContract';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { requestHdr as __requestHdr } from '../core/request';

export class TerminalContractsService {
    
    /**
     * @param id 
     * @returns Terminal Success
     * @throws ApiError
     */
    public static async get(token: string,
        id: number,
    ): Promise<TerminalContract[]> {
        return await __request(OpenAPI, {
            method: 'GET',
            url: `/api/TerminalContracts/${id}`,
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    /**
  * @param requestBody 
  * @returns Terminal Success
  * @throws ApiError
  */
    public static async post(token: string,
        requestBody?: TerminalContract,
    ): Promise<TerminalContract> {
        return await __request(OpenAPI, {
            method: 'POST',
            url: `/api/TerminalContracts`,
            body: requestBody,
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static async put(token: string,
        id: number,
        requestBody?: TerminalContract,
    ): Promise<any> {
        const result = await __request(OpenAPI, {
            method: 'PUT',
            url: `/api/TerminalContracts/${id}`,
            body: requestBody,
            headers: { Authorization: `Bearer ${token}` }
        });
        return result;
    }


    /**
     * @param id 
     * @returns any Success
     * @throws ApiError
     */
    public static async delete(token: string,
        id: number,
    ): Promise<any> {
        const result = await __request(OpenAPI, {
            method: 'DELETE',
            url: `/api/TerminalContracts/${id}`,
            headers: { Authorization: `Bearer ${token}` }
        });
        return result;
    }

    public static async propertyInfo(token: string, poi: string
    ): Promise<any> {
        const result = await __request(OpenAPI, {
            method: 'GET',
            url: `/api/TerminalContracts/propertyInfo/${poi}`,
            headers: { Authorization: `Bearer ${token}` }
        });
        return result;
    }
}